import { render } from "./NumericKeyboard.vue?vue&type=template&id=e20a4f76&scoped=true"
import script from "./NumericKeyboard.vue?vue&type=script&lang=js"
export * from "./NumericKeyboard.vue?vue&type=script&lang=js"

import "./NumericKeyboard.vue?vue&type=style&index=0&id=e20a4f76&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20a4f76"]])

export default __exports__